import axios from "./axios";

/**
 * [XSAPI] Currency - currency list 조회
 * @returns
 */
export const requestCurrencyList = async () => {
  let response = null;

  try {
    response = await axios.get("/currency/list");
  } catch (error) {
    throw new Error(error);
  }
  return response;
};
